/* eslint-disable sonarjs/cognitive-complexity */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { useHistory, useLocation } from 'react-router-dom';
import { message as toaster } from 'antd';
// import moment from 'moment';
import { Box, Image, Text, Flex } from 'atoms';
import goBack from 'assets/go-back.svg';
import RefreshIcon from 'assets/refresh.svg';
import denomination from 'assets/denomination.svg';
// import qrCode from 'assets/qr-code.svg';
// import Avatar from 'assets/Avatar.svg';
import CloseArrow from 'assets/icons/close-arrow.svg';
import { setShowLogout, setinvoiceDate, TODAY } from 'store/appSlice';
import {
	Denomination,
	// QRCodeModal,
	MakeAllBillBack,
	ClearConfirmation,
	RejectionNotificationPusher,
} from 'components/pages/collection';
import { getInvoices } from 'store/invoiceSlice';
import { useQueryParams } from 'hooks';
// import { DetailedModal } from 'components/pages/collection/delegation';
// import analytics from 'api/analytics';
import { AR } from 'utils/constants';
// import { GetFullName } from 'utils';
import { setselectedSalesMan } from 'store/userSlice';
import DetailedModal from './DetailedModal';

const ShowDetailsWrapper = styled.div`
	width: 95px;
	height: 44px;
	border-radius: 50%;
	background: #fff;
	text-align: center;
	position: fixed;
	top: 0;
	z-index: 1;
	margin-top: -22px;
	left: 50%;
	cursor: pointer;
	transform: translateX(-50%);
`;

const ShowDetailsArrow = styled(Flex)`
	width: 95px;
	height: 22px;
	margin-top: 22px;
`;

export default function CollectionHeader() {
	const [isDenominationVisible, setDenominationVisible] = useState(false);
	const [isAnyPending, setIsAnyPending] = useState(false);
	const [showDetailView, setShowDetailView] = useState(false);

	// const [isQrCodeVisible, setQrCodeVisible] = useState(false);
	const [showAllBillBackModal, setShowAllBillBackModal] = useState(false);
	const [showGoBackConfirmation, setShowGoBackConfirmation] = useState(false);
	const { me = {}, selectedSalesMan = {} } = useSelector((state) => state.user);
	const { invoiceDate } = useSelector((state) => state.app);
	const {
		invoices = [],
		isInvoiceOpen = false,
		isAccordionOpen,
	} = useSelector((state) => state.invoice);

	const dispatch = useDispatch();
	const history = useHistory();
	const location = useLocation();
	const { salesmanId = undefined } = useQueryParams();

	useEffect(() => {
		// let pendingStatus = false;

		/**
		 *  If there is any "Pending" status in receivedInvoiceList and invoices
		 *  If "yes" pendingStatus will assigned as true
		 * */

		// denomination
		console.log(invoices);
		if (invoices?.some((item) => item?.status === 'Pending')) {
			setIsAnyPending(true);
		}

		// // delegation
		// if (
		// 	invoices?.some(
		// 		(item) =>
		// 			item?.status === 'Pending' &&
		// 			moment(item?.collection_date).isSame(Date.now(), 'day')
		// 	)
		// )
	}, [invoices, location]);

	function goToSalesMenListPage() {
		dispatch(setselectedSalesMan({}));
		setTimeout(() => {
			history.push('sales-men');
		}, 1000);
	}

	const showModal = () => {
		if (isInvoiceOpen) {
			toaster.error('Please close the invoice');
		} else if (me?.type === AR) {
			goToSalesMenListPage();
		} else if (isAnyPending) {
			/**
			 * In Additional Resource login, if they click back it will go back to sales men list page
			 */
			setShowAllBillBackModal(true);
		} else {
			setShowDetailView(false);
			dispatch(setShowLogout(true));
		}
	};

	const checkAccordionStatus = () => {
		/**
		 * If selected date is not today date means, on clicking on logout first the date will be changed to today date
		 */

		if (location?.pathname === '/store') {
			setShowGoBackConfirmation(true);
		} else if (me?.type === AR) {
			goToSalesMenListPage();
		} else if (invoiceDate !== TODAY) {
			dispatch(setinvoiceDate(TODAY));
		} else if (!isAccordionOpen && isInvoiceOpen && isAnyPending) {
			/**
			 * If any invoice is still in pending state, before logout it will ask to force bill back
			 */
			setShowAllBillBackModal(true);
		} else {
			showModal();
		}
	};

	function showDenomination() {
		setDenominationVisible(true);
	}

	function hideDenomination() {
		setDenominationVisible(false);
	}

	function showDetailedView1() {
		setShowDetailView(true);
	}

	const hideDetailedView = () => {
		setShowDetailView(false);
	};

	function getLatestInvoices() {
		dispatch(getInvoices(salesmanId));
	}

	// function handleDeligationTrue() {
	// 	const eventData = {
	// 		category: 'Deligation',
	// 		action: `${me?.mobile}_${GetFullName.userFullName(me)}_Clicked_Deligation`,
	// 		label: `${GetFullName.userFullName(me)}`,
	// 		value: me?.mobile,
	// 	};

	// 	analytics.sendEvent(eventData);
	// }

	// function handleDeligation() {
	// 	dispatch(setDeligationStatus(true));
	// 	dispatch(setPanelKey(['1']));
	// 	handleDeligationTrue();
	// }

	function handleRedirect() {
		if (me.type === AR) {
			history.push(`/collection?salesmanId=${selectedSalesMan?.id}`);
		} else {
			history.push('/collection');
		}
	}

	return (
		<>
			{invoices?.length > 0 &&
				!isAnyPending &&
				!showDetailView &&
				location?.pathname !== '/store' && (
					<ShowDetailsWrapper onClick={showDetailedView1}>
						<ShowDetailsArrow
							alignItems="center"
							flexDirection="column"
							justifyContent="center"
						>
							<Image src={CloseArrow} alt="Down Arrow" width={17} />
						</ShowDetailsArrow>
					</ShowDetailsWrapper>
				)}
			<MakeAllBillBack
				visible={showAllBillBackModal}
				hide={() => setShowAllBillBackModal(false)}
			/>
			<Flex
				justifyContent="space-around"
				alignItems="center"
				height="44px"
				bg="#0168D0"
				color="#fff"
			>
				<Box cursor="pointer" onClick={checkAccordionStatus}>
					<Image src={goBack} alt="Logout" height={12} width={12} />
				</Box>
				<Text fontSize="12px">Collection Page</Text>
				<Flex justifyContent="flex-end" alignItems="center" width="60%">
					<Box
						cursor="pointer"
						mx="12px"
						onClick={getLatestInvoices}
						pr={location?.pathname === '/store' ? '45%' : '0'}
					>
						<Image src={RefreshIcon} alt="RefreshIcon" height={24} width={24} />
					</Box>
					{location?.pathname !== '/store' && (
						<RejectionNotificationPusher getLatestInvoices={getLatestInvoices} />
					)}
					{invoices?.length > 0 && !isAnyPending && location?.pathname !== '/store' && (
						<Box cursor="pointer" mx="12px" onClick={showDenomination} mt="5px">
							<Image src={denomination} alt="Denomination" height={19} width={26} />
						</Box>
					)}
				</Flex>
			</Flex>
			{isDenominationVisible && (
				<Denomination onClose={hideDenomination} detailView={showDetailedView1} />
			)}

			{/* Summary modal */}
			{showDetailView && (
				<DetailedModal
					width={455}
					showModal={showModal}
					visible={showDetailView}
					hideDetailedView={hideDetailedView}
				/>
			)}

			<ClearConfirmation
				visible={showGoBackConfirmation}
				onClose={() => setShowGoBackConfirmation(false)}
				onClear={handleRedirect}
				infoText="Are you sure want to go back to collections, this will clear the entered values"
				yesText="Yes"
			/>
		</>
	);
}
